import { Link } from 'react-router-dom'
import { Anchor, Group, SimpleGrid, Stack, Text, Title } from 'components'
import { useArcTranslation } from 'hooks'
import { useManagerDashboard } from '../context/ManagerDashboardContext'
import { ProjectMiniCard } from './ProjectMiniCard'
import { GridSkeleton } from './GridSkeleton'
import { GRID_BREAKPOINTS, GRID_COLS, PROJECTS_VIEW_ALL_URL } from '../constants'

/** "Latest assigned projects" section with a link to the full, paginated list. */
export const LatestProjectsSection = () => {
  const { t } = useArcTranslation()
  const { projects, projectsLoading, projectsError } = useManagerDashboard()

  const renderBody = () => {
    if (projectsLoading) return <GridSkeleton />
    if (projectsError) {
      return (
        <Text color='dimmed' size='sm' role='alert'>
          {t('manager_dashboard.projects_error')}
        </Text>
      )
    }
    if (projects.length === 0) {
      return (
        <Text color='dimmed' size='sm'>
          {t('manager_dashboard.empty_projects')}
        </Text>
      )
    }
    return (
      <SimpleGrid cols={GRID_COLS} spacing='md' breakpoints={GRID_BREAKPOINTS}>
        {projects.map(project => (
          <ProjectMiniCard key={project.id} project={project} />
        ))}
      </SimpleGrid>
    )
  }

  return (
    <Stack spacing='sm'>
      <Group position='apart' align='center'>
        <Title order={2} size='h4'>
          {t('manager_dashboard.latest_projects_title')}
        </Title>
        <Anchor component={Link} to={PROJECTS_VIEW_ALL_URL} size='sm'>
          {t('manager_dashboard.view_all_projects')}
        </Anchor>
      </Group>
      {renderBody()}
    </Stack>
  )
}
